<template>
    <div v-if="additionals">
        <List
            :fields="fields"
            :plantao-faixa-etaria-id="additionals.plantaoFaixaEtariaId"
            :setor-tipo-id="enums.setorTipo.RECEPCAO"
            @status-tipo-changed="handleStatusTipoChanged"
        >
            <template v-slot:custom-actions="{ item }">
                <slot
                    name="custom-actions"
                    v-bind:item="item"
                />

                <rkm-button
                    @click="handleDestroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </List>
    </div>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/fila/List'

// Enums.
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'
import statusTipo from '@/enums/painel-senha/statusTipo'

// Mixins.
import { error, repository } from '@/mixins'

export default {
    components: { List },
    computed: {
        fields() {
            if (this.model.statusTipoId === this.enums.statusTipo.EM_ATENDIMENTO) {
                return [
                    { key: 'opcaoEntrada.nome', label: 'Opção de entrada' },
                    { key: 'senha', label: 'Senha' },
                    { key: 'prioridade', label: 'Prioridade' },
                    { key: 'profissional.nome', label: 'Profissional' },
                    { key: 'actions', label: 'Ações', class: 'col-min text-center' },
                ]
            }

            return [
                { key: 'tempoEspera', label: 'Tempo de espera', class: 'col-min' },
                { key: 'opcaoEntrada.nome', label: 'Opção de entrada' },
                { key: 'senha', label: 'Senha' },
                { key: 'prioridade', label: 'Prioridade' },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
    },
    created() {
        this.repositories.fila = this.getConectaSusRepository('prontoAtendimento.fila')
        this.repositories.recepcao = this.getConectaSusRepository('prontoAtendimento.atendimentoRecepcao')
    },
    data: () => ({
        additionals: null,
        enums: { setorTipo, statusTipo },
        model: {
            statusTipoId: null,
        },
        repositories: {
            fila: null,
            recepcao: null,
        },
    }),
    methods: {
        handleStatusTipoChanged(id) {
            this.model.statusTipoId = id
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.fila.destroy(item.id)
            this.showDeleteConfirmation('Deseja realmente excluir a senha?', destroy, this.handleError)
        },
        load() {
            this.repositories.recepcao.index()
                .then(response => {
                    this.additionals = response.data.additionals
                    this.model.currentPlantaoId = this.additionals.plantaoId

                    this.$emit('additionals', response.data.additionals)
                })
                .catch(this.handleError)
        },
    },
    mixins: [ error, repository ],
    mounted() {
        this.load()
    },
}
</script>